import { render, staticRenderFns } from "./ListCover.vue?vue&type=template&id=5476e112&scoped=true&"
import script from "./ListCover.vue?vue&type=script&lang=js&"
export * from "./ListCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476e112",
  null
  
)

export default component.exports